import { apiSlice } from "app/api/apiSlice"

export const healthDataUploadApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        // upload health data
        uploadHealthData: builder.mutation({
            query: (detections) => {
                return {
                    url: 'health/data/healthDetections',
                    method: 'POST',
                    body: detections
                }
            }
        }),
        uploadHealthEvents: builder.mutation({
            query: (events) => {
                return {
                    url: 'health/data/healthEvents',
                    method: 'POST',
                    body: events
                }
            }
        }),
        getMyHealthPatientDetail: builder.query({
            query: () => {
                return {
                    url: 'health/patient/my',
                    method: 'GET',
                }
            }
        }),
    })
})

export const {
    useUploadHealthDataMutation,
    useUploadHealthEventsMutation,
    useGetMyHealthPatientDetailQuery
} = healthDataUploadApiSlice
